import { Component } from '@mycolorway/tao';
import $ from 'jquery';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import 'next/stylesheets/components/projects/todo-filter-completion-status';

Component('tr-todo-filter-completion-status', {
  mixins: [eventListenerMixin],

  properties: {
    filterUrl: {
      type: String,
    },
  },

  connected() {
    this.listenTo(this.querySelector('tr-menu'), 'tao:selected', (e) => {
      const { value } = e.detail.item.dataset;
      $.post(this.filterUrl, { value }, () => {}, 'script');
    });
  },

  disconnected() {
    this.stopListening();
  },
});
